import brandLockup from "../assets/images/icons/brand-lockup.svg";
import monogram from "../assets/images/icons/monogram.svg";
import { useTranslation } from "./Localization";

export default function Brand({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  if (compact) {
    return <img className="brand-mark" src={monogram} alt={t("accessibility.brand")} />;
  }

  return (
    <div className="brand">
      <img src={brandLockup} alt={t("accessibility.brand")} />
    </div>
  );
}
